var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-check p-0"},[_c('input',{staticClass:"form-check-input",attrs:{"id":_vm.id,"type":"Checkbox","name":_vm.name},domProps:{"checked":_vm.checked}}),_c('label',{attrs:{"for":_vm.id}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }